<template>
<kt-panel>
    <div class="accordion accordion-toggle-arrow" id="userFilter">
        <div class="card" style="overflow:inherit">
            <div class="card-header bg-transparent" id="headingOne">
                <div class="card-title collapsed" data-toggle="collapse" 
                    data-target="#filterForm"
                    aria-controls="filterForm">
                    {{ $t('label.search') }}
                </div>
            </div>
            <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                <div class="card-body">
                    <form @submit.prevent="action($event, query)">
                        <kt-form-section>
                            <kt-form-row>
                                <kt-col md="4">
                                    <kt-form-group>
                                        <kt-form-label for="full_name">
                                            {{ $t('label.full_name') }}
                                        </kt-form-label>
                                        <kt-form-control ref="full_name" name="full_name" id="full_name" v-model="query.full_name" />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col md="4">
                                    <kt-form-group>
                                        <kt-form-label for="cellphone_number">
                                            {{ $t('label.phone') }}
                                        </kt-form-label>
                                        <kt-form-control ref="cellphone_number" dir="ltr" name="cellphone_number" id="cellphone_number" v-model="query.cellphone_number" />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col md="4">
                                    <kt-form-group>
                                        <kt-form-label for="telephone_number">
                                            {{ $t('label.telephone') }}
                                        </kt-form-label>
                                        <kt-form-control ref="telephone_number" dir="ltr" name="telephone_number" id="telephone_number" v-model="query.telephone_number" />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col md="4">
                                    <kt-form-group>
                                        <label for="type" v-text="$t('label.type')"></label>
                                        <select id="type"
                                                ref="type"
                                                name="type"
                                                class="form-control kt-selectpicker"
                                                v-model="query.type">
                                            <option :value="relatedMerchantType.GATEWAY" v-text="relatedMerchantTypeStr.get(relatedMerchantType.GATEWAY)"></option>
                                            <option :value="relatedMerchantType.WALLET" v-text="relatedMerchantTypeStr.get(relatedMerchantType.WALLET)"></option>
                                            <option :value="relatedMerchantType.PSP" v-text="relatedMerchantTypeStr.get(relatedMerchantType.PSP)"></option>
                                        </select>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col md="4">
                                    <kt-form-group>
                                        <label for="merchant_type" v-text="$t('label.merchant_type')"></label>
                                        <select id="merchant_type"
                                                ref="merchant_type"
                                                name="merchant_type"
                                                class="form-control kt-selectpicker"
                                                v-model="query.merchant_type">
                                            <option :value="merchant_type.REAL" v-text="merchant_type_str.get(merchant_type.REAL)"></option>
                                            <option :value="merchant_type.LEGAL" v-text="merchant_type_str.get(merchant_type.LEGAL)"></option>
                                        </select>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col md="4">
                                    <kt-form-group>
                                        <label for="status" v-text="$t('label.status')"></label>
                                        <select id="status"
                                                ref="status"
                                                name="status"
                                                class="form-control kt-selectpicker"
                                                v-model="query.status">
                                            <option :value="stakeholder_status.CREATED"  v-text="stakeholder_status_str.get(stakeholder_status.CREATED)"></option>
                                            <option :value="stakeholder_status.PENDING"  v-text="stakeholder_status_str.get(stakeholder_status.PENDING)"></option>
                                            <option :value="stakeholder_status.ACTIVE"   v-text="stakeholder_status_str.get(stakeholder_status.ACTIVE)"></option>
                                            <option :value="stakeholder_status.REJECTED" v-text="stakeholder_status_str.get(stakeholder_status.REJECTED)"></option>
                                            <option :value="stakeholder_status.BLOCKED"  v-text="stakeholder_status_str.get(stakeholder_status.BLOCKED)"></option>
                                        </select>
                                    </kt-form-group>
                                </kt-col>
                            </kt-form-row>
                        </kt-form-section>

                        <kt-form-section>
                            <kt-row>
                                <kt-col md="4">
                                    <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                                </kt-col>
                            </kt-row>
                        </kt-form-section>
                    </form>
                </div>
            </div>
        </div>
    </div>
</kt-panel>
</template>

<script>
import $ from 'jquery';
import { i18n } from '@/plugins/i18n';
import { merchantType, merchantTypeStr } from '@/constants/merchantType';
import { stakeholderStatus, stakeholderStatusStr } from '@/constants/stakeholderStatus';
import { relatedMerchantType, relatedMerchantTypeStr, relatedMerchantTypeVariant } from '@/constants/related_merchant_type';

export default {
    props: {
        action: {
            default: function(e, query) {},
            required: true,
        },
    },
    data() {
        return {
            merchant_type: merchantType,
            merchant_type_str: merchantTypeStr,
            stakeholder_status: stakeholderStatus,
            stakeholder_status_str: stakeholderStatusStr,
            query: {},
            relatedMerchantType: relatedMerchantType,
            relatedMerchantTypeStr: relatedMerchantTypeStr,
            relatedMerchantTypeVariant: relatedMerchantTypeVariant,
        };
    },
    mounted() {
        setTimeout(() => {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: false,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            });
        }, 1000);
    },
}
</script>
